import {
  Box,
  Button,
  Container,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuList,
  Text,
} from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import UpIcon from "#/assets/arrow-up-right.svg"
import ChevronDownIcon from "#/assets/dropdown-arrow.svg"

type HeaderNavItem = {
  title: string
  url: string
  dropdownItems?: {
    title: string
    description: string
    url: string
    linkTarget: boolean
  }[]
}

type HeaderSectionProps = {
  headerNav?: HeaderNavItem[]
}

export default function LandingHeader({ headerNav = [] }: HeaderSectionProps) {
  return (
    <Container
      maxW="100%"
      p={0}
      pt={10}
      height="auto"
      mt="-184px"
      position="relative"
    >
      <Box
        position="relative"
        zIndex="900"
        maxWidth="350px"
        margin="auto"
        display={{ base: "none", sm: "none", md: "block" }}
      >
        {headerNav.length > 0 && (
          <Flex
            textAlign="center"
            borderRadius="30px"
            maxWidth="420px"
            margin="auto"
            mt="-22px"
            p="3px"
            justifyContent="center"
          >
            {headerNav.map((item) =>
              item.dropdownItems ? (
                <Menu key={item.title} isLazy>
                  <MenuButton
                    as={Button}
                    p="9px 15px"
                    bg="transparent"
                    borderRadius="30px"
                    className={`topnav-${item.title.toLowerCase()}`}
                    data-attr={`topnav-${item.title.toLowerCase()}`}
                    color="black"
                    fontSize="16px"
                    fontFamily="riforma.medium"
                    fontWeight="500"
                    _active={{
                      bg: "primary.black.10",
                    }}
                    _hover={{
                      bg: "primary.black.100",
                      color: "primary.white.100",
                    }}
                    sx={{
                      "&:hover img": {
                        filter: "invert(1)",
                      },
                    }}
                  >
                    <Flex align="center" gap={1}>
                      {item.title}
                      <Image src={ChevronDownIcon} p="5px 2px" mr="10px" />
                    </Flex>
                  </MenuButton>
                  <MenuList p={4} borderRadius="lg" minW="200px">
                    <Flex direction="row" gap={2}>
                      {item.dropdownItems.map((dropdown) => (
                        <Link
                          to={dropdown.url}
                          target={dropdown.linkTarget ? "_blank" : undefined}
                        >
                          <Box
                            p={2}
                            borderRadius="md"
                            textAlign="left"
                            _hover={{ bg: "gray.50" }}
                          >
                            <Flex>
                              <Text
                                fontFamily="riforma.medium"
                                fontWeight="500"
                                mb={1}
                              >
                                {dropdown.title}
                              </Text>
                              {dropdown.linkTarget && (
                                <Image src={UpIcon} p="5px 2px" mr="10px" />
                              )}
                            </Flex>
                            {dropdown.description && (
                              <Text fontSize="sm" color="gray.600">
                                {dropdown.description}
                              </Text>
                            )}
                          </Box>
                        </Link>
                      ))}
                    </Flex>
                  </MenuList>
                </Menu>
              ) : (
                <Link to={item.url} key={item.title}>
                  <Button
                    p="9px 15px"
                    bg="transparent"
                    borderRadius="30px"
                    className={`topnav-${item.title.toLowerCase()}`}
                    data-attr={`topnav-${item.title.toLowerCase()}`}
                    color="black"
                    fontSize="16px"
                    fontFamily="riforma.medium"
                    fontWeight="500"
                    _hover={{
                      bg: "primary.black.100",
                      color: "primary.white.100",
                    }}
                  >
                    {item.title}
                  </Button>
                </Link>
              ),
            )}
          </Flex>
        )}
      </Box>
    </Container>
  )
}
